import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useDashboardStore } from '../../../store/dashboardStore';
import { GameHeader } from './components/GameHeader';
import { NumberLine } from './components/NumberLine';
import { ClueBoard } from './components/ClueBoard';
import { useFactorGame } from './hooks/useFactorGame';

export const FactorDetective: React.FC = () => {
  const navigate = useNavigate();
  const { addPoints } = useDashboardStore();
  const {
    currentNumber,
    clues,
    secretWord,
    discoveredLetters,
    score,
    gameOver,
    checkFactor
  } = useFactorGame();

  const handleFactorCheck = (factor: number) => {
    const isCorrect = checkFactor(factor);
    if (isCorrect) {
      addPoints(10); // Award points for correct answers
    }
  };

  const handleGameComplete = () => {
    addPoints(score * 2); // Bonus points for completing the game
    setTimeout(() => {
      navigate('/dashboard');
    }, 3000);
  };

  useEffect(() => {
    if (gameOver) {
      handleGameComplete();
    }
  }, [gameOver]);

  return (
    <div className="min-h-screen bg-[#4558C8] text-white p-8">
      <GameHeader score={score} />
      
      <div className="max-w-4xl mx-auto space-y-8 mt-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white/20 rounded-2xl p-6"
        >
          <h2 className="text-3xl font-bold mb-4">Current Number: {currentNumber}</h2>
          <p className="text-xl mb-6">Find all factors of this number to reveal the secret word!</p>
          
          <NumberLine 
            number={currentNumber}
            onFactorCheck={handleFactorCheck}
          />
        </motion.div>

        <ClueBoard
          clues={clues}
          secretWord={secretWord}
          discoveredLetters={discoveredLetters}
        />

        {gameOver && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            className="fixed inset-0 bg-black/50 flex items-center justify-center"
          >
            <div className="bg-white text-[#4558C8] p-8 rounded-2xl text-center">
              <h2 className="text-4xl font-bold mb-4">Congratulations!</h2>
              <p className="text-2xl mb-4">You solved the mystery!</p>
              <p className="text-xl mb-4">Total Score: {score}</p>
              <p className="text-lg">Returning to dashboard...</p>
            </div>
          </motion.div>
        )}
      </div>
    </div>
  );
};